<template>
  <div class="clear">
    <div class="ca">
      <p class="qdTitle">CA签到</p>
      <div class="errorMsg">
        <p>{{ errorMsg }}</p>
      </div>
        <div class="ca-qd-dom">
          <div ref="ca_qd_dom"></div>
        </div>
        <div style="text-align:center">
          <el-button
            type="primary"
            :disabled="waitLoading"
            @click="checkCAUserForm()"
            >签到</el-button
          >
        </div>
    </div>
     <!-- <div class="ewm">
      <div>
        <p class="qdTitle">二维码签到</p>
        <img
          :src="ewmUrl"
          alt=""
          style="width:243px;height:243px;margin-bottom:10px;"
          @click="getQdEwm()"
        />
        <p>请用手机证书APP扫描二维码</p>
      </div>
    </div> -->
    <object
      id="USBKeyApi"
      classid="clsid:1246FA8B-41FD-4B45-90B8-47ED9772A1CD"
      style="position: absolute;top:-5000px"
    >
      <embed name="USBKeyApi" type="application/npSOFSignApi-plugin" />
    </object>
  </div>
</template>
<script>
import setting  from "@/settings"
export default {
  name: "qdCom",
  props: [],
  data() {
    return {
      errorMsg: "",
      ewmDsq: "", //二维码定时器判断扫码
      ewmUrl: "",
      getTime: "", //获取二维码的定时器2分钟一次
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      waitLoading:false,
      lock_:null,
      config: {
        select: {
          style: {
            width: "380px",
            backgroundSize: "17px 14px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "8px center",
          },
          placeholder: "请选择CA证书",
          userCheckRequest: setting.stystemLx,
          userCheckUrl:setting.caCheckUrl
        },
        detection: {
          name: "检 测",
        },
        pin: {
          style: {
            width: "480px",
            backgroundSize: "13px 21px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "8px center",
          },
          maxLength: 16,
          placeholder: "请输入CA密码",
        },
        style: "loginOne",
        certInfoCode: [
          "NOTBEFORE",
          "AFTER",
          "ORGANIZATIONCODE",
          "SUBJECT_O",
          "PUBKEY",
        ], // 证书信息 不传默认返回锁的名字,证书序列号,锁的类型
        callback: (res) => {
          if (res.state == "succeed") {
            if(res.type == "login"){
              this.$emit('Qd',{jgdm:res.data.currentUser.ORGANIZATIONCODE,code:res.data.currentUser.code})
              this.errorMsg=''
            }
          }
        },
        callMessage: {},
      },
    };
  },
  methods: {
    //获取二维码
    getQdEwm() {
      clearInterval(this.getTime);
      this.getTime = null;
      clearTimeout(this.ewmDsq);
      this.ewmDsq = null;
      this.getTime = setInterval(() => {
        this.getQdEwm();
      }, 120000);
      this.$api
        .getQdEwm()
        .then((res) => {
          this.ewmUrl = "data:image/gif;base64," + res.data.picdata;
          this.uuid = res.data.uuid;
          this.setQdSrc();
        })
        .catch(() => {});
    },
    //验证扫描二维码是否成功
    setQdSrc() {
      clearTimeout(this.ewmDsq);
      this.ewmDsq = null;
      this.ewmDsq = setTimeout(() => {
        this.setQdSrc();
      }, 2000);
      let para = {
        uuid: this.uuid,
      };
      let _this = this;
      this.$api
        .setQdSrc(para)
        .then((res) => {
          //扫码成功后
          if (res.data.data != null && res.data.data != "") {
            clearInterval(_this.ewmDsq);
            _this.ewmDsq = null;
            let obj = {
              jgdm: res.data.data.jgdm,
              qymc: res.data.data.qymc,
            };
            _this.$emit("ewmQd", obj);
          }
        })
        .catch(() => {});
    },
    // 签到
    checkCAUserForm(){
        this.lock_.checkPin(this.lock_.currentUser)
    }
  },
  mounted() {
    clearInterval(this.getTime);
    this.getTime = null;
    clearTimeout(this.ewmDsq);
    this.ewmDsq = null;
    this.getQdEwm();
    if (this.$refs.ca_qd_dom) {
      this.lock_ = new lock();
      this.lock_.init(this.$refs.ca_qd_dom, this.config);
    }
  },
  beforeDestroy() {
    clearInterval(this.getTime);
    this.getTime = null;
    clearTimeout(this.ewmDsq);
    this.ewmDsq = null;
  },
};
</script>
<style lang="less" scoped>
div.ca {
  width: 60%;
  padding-right: 100px;
  position: relative;
  float: left;
  height: 350px;
  .el-select {
    width: calc(~"100% - 110px");
    margin-right: 10px;
  }
}
div.ca:after {
  content: "";
  border-left: 1px solid #ddd;
  height: 320px;
  position: absolute;
  top: 0;
  right: 0;
}
div.ewm {
  > div {
    width: 250px;
    text-align: center;
    margin: 0 auto;
    p.qdTitle {
      text-align: left;
    }
  }
  width: 40%;
  float: left;
  img {
    display: block;
    background: #fff;
  }
}
p {
  color: #666;
  font-size: 16px;
}
p.qdTitle {
  color: #333;
  font-size: 18px;
  margin-bottom: 20px;
}
.allWidth {
  div.ca {
    width: 630px;
    text-align: center;
  }
  div.ewm {
    width: 500px;
  }
}
.ca-qd-dom{
    display: flex;
    justify-content: center;
}
</style>
